// 文件类型识别与预览策略

export const FILE_TYPE = {
  IMAGE: 'image',
  PDF: 'pdf',
  DOCX: 'docx',
  XLSX: 'xlsx',
  DOC: 'doc',
  XLS: 'xls',
  PPT: 'ppt',
  PPTX: 'pptx',
  VIDEO: 'video',
  AUDIO: 'audio',
  ARCHIVE: 'archive',
  TEXT: 'text',
  FILE: 'file'
}

const EXT_TYPE_MAP = {
  jpg: FILE_TYPE.IMAGE, jpeg: FILE_TYPE.IMAGE, png: FILE_TYPE.IMAGE, gif: FILE_TYPE.IMAGE,
  webp: FILE_TYPE.IMAGE, bmp: FILE_TYPE.IMAGE, svg: FILE_TYPE.IMAGE, ico: FILE_TYPE.IMAGE,
  pdf: FILE_TYPE.PDF,
  docx: FILE_TYPE.DOCX, doc: FILE_TYPE.DOC,
  xlsx: FILE_TYPE.XLSX, xls: FILE_TYPE.XLS,
  pptx: FILE_TYPE.PPTX, ppt: FILE_TYPE.PPT,
  zip: FILE_TYPE.ARCHIVE, rar: FILE_TYPE.ARCHIVE, '7z': FILE_TYPE.ARCHIVE, tar: FILE_TYPE.ARCHIVE, gz: FILE_TYPE.ARCHIVE,
  mp4: FILE_TYPE.VIDEO, mov: FILE_TYPE.VIDEO, avi: FILE_TYPE.VIDEO, mkv: FILE_TYPE.VIDEO, webm: FILE_TYPE.VIDEO,
  mp3: FILE_TYPE.AUDIO, wav: FILE_TYPE.AUDIO, flac: FILE_TYPE.AUDIO, aac: FILE_TYPE.AUDIO, ogg: FILE_TYPE.AUDIO,
  txt: FILE_TYPE.TEXT, log: FILE_TYPE.TEXT, md: FILE_TYPE.TEXT, json: FILE_TYPE.TEXT, csv: FILE_TYPE.TEXT
}

const CONTENT_TYPE_PREFIX_MAP = {
  'image/': FILE_TYPE.IMAGE,
  'video/': FILE_TYPE.VIDEO,
  'audio/': FILE_TYPE.AUDIO,
  'application/pdf': FILE_TYPE.PDF,
  'application/zip': FILE_TYPE.ARCHIVE,
  'application/x-rar-compressed': FILE_TYPE.ARCHIVE,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': FILE_TYPE.DOCX,
  'application/msword': FILE_TYPE.DOC,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': FILE_TYPE.XLSX,
  'application/vnd.ms-excel': FILE_TYPE.XLS,
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': FILE_TYPE.PPTX,
  'application/vnd.ms-powerpoint': FILE_TYPE.PPT,
  'text/': FILE_TYPE.TEXT
}

export function getExt(filename) {
  if (!filename) return ''
  const clean = String(filename).split('?')[0].split('#')[0]
  const idx = clean.lastIndexOf('.')
  if (idx < 0) return ''
  return clean.slice(idx + 1).toLowerCase()
}

export function getFileType(file) {
  if (!file) return FILE_TYPE.FILE
  const ct = file.contentType || file.type
  if (ct && CONTENT_TYPE_PREFIX_MAP[ct]) return CONTENT_TYPE_PREFIX_MAP[ct]
  for (const [prefix, type] of Object.entries(CONTENT_TYPE_PREFIX_MAP)) {
    if (ct && prefix.endsWith('/') && ct.startsWith(prefix)) return type
  }
  const ext = getExt(file.name || file.fileName || file.originalName || file.fileKey)
  return EXT_TYPE_MAP[ext] || FILE_TYPE.FILE
}

// 预览策略：image / pdf / docx / xlsx / office / download
export function getPreviewStrategy(file) {
  const type = getFileType(file)
  if (type === FILE_TYPE.IMAGE) return 'image'
  if (type === FILE_TYPE.PDF) return 'pdf'
  if (type === FILE_TYPE.DOCX) return 'docx'
  if (type === FILE_TYPE.XLSX) return 'xlsx'
  if (type === FILE_TYPE.PPT || type === FILE_TYPE.PPTX) return 'office'
  return 'download'
}

export function isPreviewable(file) {
  return getPreviewStrategy(file) !== 'download'
}

export function isImage(file) {
  return getFileType(file) === FILE_TYPE.IMAGE
}

// 文件名展示
export function getFileName(file) {
  if (!file) return '附件'
  if (typeof file === 'string') return file.split('/').pop() || file
  return file.name || file.originalName || file.fileName || file.fileKey || '附件'
}

// 文件大小展示
export function getFileSize(file) {
  if (!file) return ''
  const size = file.size ?? file.fileSize
  if (size == null || isNaN(size)) return ''
  if (size < 1024) return `${size} B`
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`
  if (size < 1024 * 1024 * 1024) return `${(size / 1024 / 1024).toFixed(1)} MB`
  return `${(size / 1024 / 1024 / 1024).toFixed(2)} GB`
}

// 取可访问 URL
export function getFileUrl(file) {
  if (!file) return ''
  if (typeof file === 'string') {
    return /^https?:\/\//i.test(file) ? file : ''
  }
  return file.url || ''
}
